import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {react} from "mobx";
import {
    FormGroup, Form,
    Input,
    Label,
    Row, Col
} from 'reactstrap'
import 'moment/locale/pt-br';

import TimesheetsStore from "../stores/TimesheetsStore";
import DataWrapper from "../../../principal/containers/DataWrapper";
import {sortAlphaNum} from "../../../../utils/ordenar";
import {formatarValorReal, formatarDataISO8601, ordenarData} from "../../../../utils/formatar";
import {Tabela} from "../../../comum/components/Tabela";
import {formatarBoolean} from "../../../../utils/functions";

import {getStatusTimesheetById} from "../../../../utils/enums";

import {Filtro} from "../../../comum/components/Filtro";

const FILTROS = ["COMPETENCIA", "EMPRESA", "FORNECEDOR","SITUACAO_TIMESHEET"];
const VALIDACOES = ["COMPETENCIA_OBRIGATORIA"];

@inject("store")
@DataWrapper
@observer
export class Timesheets extends Component {

    constructor(props) {
        super(props);

        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.formStore = this.props.store.formStore;
        this.modalStore = this.props.store.modalStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.loginStore = this.props.store.loginStore;

        this.controller = new TimesheetsStore();
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Timesheets");
    }

    formatarStatus = (valor) => {
            const status = getStatusTimesheetById(valor);

            return status.valor;
    };

    render() {
        const COLUNAS = [
            {
                field: "cpf",
                label: "CPF",
                mobileWidth: 100
            },{
                field: "nomeCompleto",
                label: "Nome",
                mobileWidth: 200
            },{
                field: "nomeGestor",
                label: "Gestor",
                mobileWidth: 200
            },{
                field: "cargo",
                label: "Cargo",
                mobileWidth: 160
            },{
                field: "solicitacaoId",
                label: "Solicitação",
                mobileWidth: 120
            },{
                field: "valorTotal",
                label: "Valor",
                dataFormat: formatarValorReal,
                funcaoOrdenacao: sortAlphaNum.bind("valorTotal"),
                mobileWidth: 160
            },{
                field: "dataAdmissao",
                label: "Admissão",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataAdmissao"),
                mobileWidth: 100
            },{
                field: "dataTermino",
                label: "Término",
                dataFormat: formatarDataISO8601,
                funcaoOrdenacao: ordenarData.bind("dataTermino"),
                mobileWidth: 100
            },{
                 field: "status",
                 label: "Status",
                 dataFormat: this.formatarStatus
             },{
               field: "aprovadoAutomaticamente",
               label: "Aprovado automaticamente",
               dataFormat: formatarBoolean
            }
        ];

        const acoesItens = [];

        acoesItens.push({
            tipo: "visualizar",
            label: "Visualizar",
            icone: "search-plus",
            cor: "text-info",
            parametro: "timesheetId",
            acao: "/detalhes-lote-pagamento/timesheet"
        });

        return (
            <div>
                <div className="form-wrapper">
                    <div className={this.appStore.width > 768 ? "content-panel" : ""}>
                     {this.appStore.width > 768 && <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                                                                   controller={this.controller}
                                                                                   history={this.props.history}
                                                                                   location={this.props.location}
                                                                                   fields={FILTROS}
                                                                                   validations={VALIDACOES}
                                                                            />}
                        <Tabela
                            keyField={"cpf"}
                            habilitarSelecaoMultipla={false}
                            listaItens={this.controller.listaItens}
                            colunas={COLUNAS}
                            temBusca={false}
                            acoesItens={acoesItens}
                            onChange={(value) => this.controller.setLista(value)}
                            loading={this.controller.loading}
                            colunaOrdenacaoPadrao={"cpf"}
                            />
                    </div>
                </div>
            </div>
        );
    }
}
